var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 523.06 131.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M65.13,87.74,54.41,53.2h-.28V87.74H46.05V43.87H59.77l9.61,31.89h.21l9.12-31.89H92.15V87.74H83.37V53.2H83.1L72.58,87.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M158.64,43.87l17.9,43.87h-9.26l-4.39-10.87H144.23L140,87.74h-8.77L149,43.87ZM146.88,70.19h13.37l-6.62-16.43h-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M223.26,87.74V51.11H207.74V43.87h40v7.24H232V87.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M301.39,87.74V51.11H285.86V43.87h40v7.24H310.1V87.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M398.88,87.74h-32.8V43.87h32.17v7.24H374.64V61.76h18.53v7.18H374.64V80.49h24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M468.09,87.74c-.9-1.19-1.46-4.18-1.81-9s-2.58-7.18-7.59-7.18h-10.3V87.74h-8.57V43.87h19.85c11.21,0,16.71,5.22,16.71,13.37,0,6.61-4.32,10.44-9.68,11.14,5,1,7.59,3.9,8.08,9.05.55,6.48.76,8.7,2.23,10.3Zm-9.61-23c6.34,0,9.26-2.09,9.26-6.83,0-4.38-2.92-7-9.26-7H448.39V64.69Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatterLogo);
export default __webpack_public_path__ + "static/media/MatterLogo.6e9b8cd85fb20a25686aba234c839634.svg";
export { ForwardRef as ReactComponent };